import { createAsyncThunk,createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL="https://estadisticas.setab.gob.mx/controles/ctrlcedest2.php?";
const API_URL_CCT="https://estadisticas.setab.gob.mx/controles/fechadatos2.php?datos=";
//const API_URL="http://localhost:8010/estadistica/controles/ctrlcedest2.php?";
//const API_URL_CCT="http://localhost:8010/estadistica/controles/fechadatos2.php?datos=";
export const obtEstadCT = createAsyncThunk('estad/requestStatus',async function (props, thunkAPI) {
    try {
      const response = await axios.get(API_URL+"cveced="+props.cveced+"&ciclo="+props.ciclocifras);
      return response.data;
    }
    catch (error) {
      console.log("error generado:" + error);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const obtFechaCCT = createAsyncThunk('cct/requestStatus',
  async function (props, thunkAPI) {
    try {
      const response = await axios.get(API_URL_CCT+props.datos);
      return response.data;
    }
    catch (error) {
      console.log("error generado:" + error);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const obtFechaC911 = createAsyncThunk('c911/requestStatus',
  async function (props, thunkAPI) {
    try {
      const response = await axios.get(API_URL_CCT+props.datos+"&ciclo="+props.ciclo);
      return response.data;
    }
    catch (error) {
      console.log("error generado:" + error);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

const initialState={
	estad:{},
  cvect: '',
  loadingestad: 'idle',
  error:'',
  fechacct:{},
  loadingfechacct: 'idle',
  errorfechacct:'',
  fechac911:{},
  loadingfechac911: 'idle',
  errorfechac911:'',
};

export const ctSlice = createSlice({
  name: 'esc',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(obtEstadCT.fulfilled, (state, action) => {
      state.estad=action.payload;
      state.loadingestad = "estad loaded";
      state.error="";
    });
    builder.addCase(obtEstadCT.pending, (state) => {
      state.loadingestad = "estad loading";
      state.error="";
    });
    builder.addCase(obtEstadCT.rejected,(state,action) => {
      state.loadingestad = "estad error";
      state.error = action.error.message;
    });
    builder.addCase(obtFechaCCT.fulfilled, (state, action) => {
      state.fechacct=action.payload;
      state.loadingfechacct = "fechacct loaded";
      state.errorfechacct="";
    });
    builder.addCase(obtFechaCCT.pending, (state) => {
      state.loadingfechacct = "fechacct loading";
      state.errorfechacct="";
    });
    builder.addCase(obtFechaCCT.rejected,(state,action) => {
      state.loadingfechacct = "fechacct error";
      state.errorfechacct = action.error.message;
    });
    builder.addCase(obtFechaC911.fulfilled, (state, action) => {
      state.fechac911=action.payload;
      state.loadingfechac911 = "fechac911 loaded";
      state.errorfechac911="";
    });
    builder.addCase(obtFechaC911.pending, (state) => {
      state.loadingfechac911 = "fechac911 loading";
      state.errorfechac911="";
    });
    builder.addCase(obtFechaC911.rejected,(state,action) => {
      state.loadingfechac911 = "fechac911 error";
      state.errorfechac911 = action.error.message;
    });
  }
});

export default ctSlice.reducer;